let loder = document.getElementById("elementLoader")

if(window.location.pathname === "/"){
  document.documentElement.scrollTop = 0;
  document.documentElement.style.overflow = 'hidden';
document.body.style.overflow = 'hidden';


setTimeout(() => {
  document.documentElement.scrollTop = 0;
    if (loder) {
  loder.style.position = "relative"
        loder.style.transition = "height 0.8s cubic-bezier(0.4, 0, 1, 1)";
        loder.style.height = "0vh";
        
        setTimeout(() => {
            loder.remove();
            document.documentElement.style.overflow = '';
            document.body.style.overflow = '';
        }, 800); 
    }
}, 1200);
}
else{
   loder.remove();
}
